import { likeHeaders } from "@/lib/useLikes";

const API = process.env.REACT_APP_BACKEND_URL;

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

function toUint8(b64) {
  const padding = "=".repeat((4 - (b64.length % 4)) % 4);
  const s = (b64 + padding).replace(/-/g, "+").replace(/_/g, "/");
  return Uint8Array.from(atob(s), (c) => c.charCodeAt(0));
}

export async function currentSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.ready;
  return reg.pushManager.getSubscription();
}

/** Asks permission (must be called from a user gesture), subscribes and stores the subscription server-side. */
export async function enablePush(lang) {
  if (!pushSupported()) throw new Error("unsupported");
  if ((await Notification.requestPermission()) !== "granted") throw new Error("denied");
  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const { publicKey } = await (await fetch(`${API}/api/push/public-key`)).json();
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toUint8(publicKey) });
  }
  const r = await fetch(`${API}/api/push/subscribe`, {
    method: "POST", headers: { "Content-Type": "application/json", ...likeHeaders() },
    body: JSON.stringify({ ...sub.toJSON(), lang }),
  });
  if (!r.ok) throw new Error("subscribe");
  return sub;
}

export async function disablePush() {
  const sub = await currentSubscription();
  if (!sub) return;
  await fetch(`${API}/api/push/subscribe`, { method: "DELETE", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ endpoint: sub.endpoint }) });
  await sub.unsubscribe();
}
